export interface SysIDashboards {
  Db_Id: EReportId; // ID del dashboard (Base de datos)
  Db_Nombre: string; // Nombre del dashboard (Base de datos)
  Db_Descripcion: string; // Descripción (Base de datos)
  Db_TiempoActualizacion: number; // Tiempo de actualización en segundos (Base de datos)
  Db_Estado: boolean; // Estado activo/inactivo (Base de datos)
  Db_Permisos: string; // Permisos asociados (Base de datos)
  Db_Tipo: EReportType; // Tipo de dashboard (Base de datos)
  Loading: boolean; // Indicador de carga (Frontend)
  Data: any; // Datos dinámicos del dashboard (Frontend)
  UltimaActualizacion?: string; // Fecha de la última actualización (Frontend)
}

export interface DashBoardState {
  dashboards: SysIDashboards[];
  loading: boolean;
}

export enum EReportId {
  AreasValidation = 1,
  PatientsValidation = 2,
  OrdersByServices = 3,
  GeneralInformation = 4,
  Analyzers = 5,
  PpalBoard = 6,
  OrdersPendingForMail = 7,
  OrdersTrends = 8,
  SalesBoard = 9,
  SalesBoardPersonal = 10,
}

export enum EReportType {
  Dynamic = 1,
  Static = 2,
}

// Interfaces específicas para OrdersTrends
export interface OrdersTrendsRawData {
  date: string;
  ordersProcessed: number;
  ordersReceived: number;
  ordersPending: number;
  period: 'current' | 'previous';
  dayOfWeek: string;
  serviceArea: string | null;
  location: string | null;
}

export interface OrdersTrendsProcessedData {
  series: Array<{
    name: string;
    data: Array<{ argument: string; value: number }>;
  }>;
  summary: {
    totalOrders: number;
    averagePerDay: number;
    percentageChange: number;
    trend: 'up' | 'down' | 'stable';
  };
}